export default __webpack_public_path__ + "static/media/poster-bg.9c21e95b.png";